import { Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from '@uzurv/afp/button';
import { MatIconModule } from '@angular/material/icon';
import { CamelCasePipe } from '@uzurv/core';

@Component({
  selector: 'app-alert-banner',
  standalone: true,
  imports: [CommonModule, ButtonModule, MatIconModule, CamelCasePipe],
  templateUrl: './alert-banner.component.html',
  styleUrls: ['./alert-banner.component.scss']
})
export class AlertBannerComponent {
  @HostBinding('class')
  @Input()
  alertType: 'info' | 'success' | 'warning' | 'danger';

  @Input() heading: string | null = null;
  @Input() message: string | null = null;
  @Input() subtext: string | null = null;

  @Input() primaryActionText: string | null = null;
  @Input() isPrimaryActionDisabled: boolean = false;
  @Output() onPrimaryAction = new EventEmitter();

  @Input() secondaryActionText: string | null = null;
  @Input() isSecondaryActionDisabled: boolean = false;
  @Output() onSecondaryAction = new EventEmitter();

  getIconName(): string {
    switch (this.alertType) {
      case 'info':
        return 'uz-info-outline';
      case 'success':
        return 'uz-check';
      case 'warning':
        return 'uz-warning-outline';
      case 'danger':
        return 'uz-warning';
      default:
        return 'uz-info-outline';
    }
  }
}
